import { Navigate } from 'react-router-dom';
import { LoadingScreen } from 'src/components/loading-screen';
import { CONFIG } from 'src/config-global';
import useAuth from './useAuth';

/**
 * @description GuestGuard component that protects routes accessible only to unauthenticated users.
 *
 * Redirects authenticated users to the dashboard and prevents them from accessing
 * guest-only pages such as login or registration.
 *
 * @example
 * ```tsx
 * <GuestGuard>
 *   <LoginPage />
 * </GuestGuard>
 * ```
 */
export default function GuestGuard({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isInitialized } = useAuth();

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (isAuthenticated) {
    return <Navigate to={CONFIG.auth?.redirectPath ?? '/dashboard'} replace />;
  }

  return <>{children}</>;
}
